module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 88.1d6a2849.png";